import React from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

const DesktopHeader = ({ title, subtitle }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.desktopHeaderWrapper}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />
    </div>
  )
}

export default DesktopHeader
